import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import LaurelSite from './App.tsx'
import { OpenPage } from './OpenPage'

const pathname = window.location.pathname
const Screen = pathname === '/open' ? OpenPage : LaurelSite

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Screen />
  </StrictMode>,
)
